import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Home from './Components/Home';
import VendorMicrosoft from './Components/VendorMicrosoft';
import VendorAWS from './Components/VendorAWS';
import VendorGoogle from './Components/VendorGoogle';
import VendorComptia from './Components/VendorComptia';
import VendorPMI from './Components/VendorPMI';
import VendorIIBA from './Components/VendorIIBA';
import VendorsPage from './Components/VendorsPage';
import HomeNew from './Components/HomeNew';
import ApplicationDevelopment from './Components/services/ApplicationDevelopment';
import SoftwareTesting from './Components/services/SoftwareTesting';
import ITConsulting from './Components/services/ITConsulting';
import ERPImplementation from './Components/services/ERPImplementation';
import DigitalMarketing from './Components/services/DigitalMarketing';
import Navbar from './Components/Navbar';
import Services from './Components/Services';
import AboutUs from './Components/AboutUs'
import ITTraining from './Components/ITTraining';
import ContactUs from './Components/ContactUs';
import ResumeApp from './Components/ResumeBuilder/ResumeApp';
import AdminApp from './Components/Admin/AdminApp';

// Component to conditionally render Navbar
const AppContent = () => {
  const location = useLocation();
  const isAdminPage = location.pathname === '/admin';
  
  return (
      <div className="App">
      {!isAdminPage && <Navbar />}
        <main>
          <Routes>
            <Route path="/" element={<HomeNew />} />
            <Route path="/microsoft" element={<VendorMicrosoft />} />
            <Route path="/aws" element={<VendorAWS />} />
            <Route path="/google-cloud" element={<VendorGoogle />} />
            <Route path="/comptia" element={<VendorComptia />} />
            <Route path="/pmi" element={<VendorPMI />} />
            <Route path="/iiba" element={<VendorIIBA />} />
            <Route path="/vendors" element={<VendorsPage />} />
            <Route path="/resume-builder" element={<ResumeApp />} />
          <Route path="/admin" element={<AdminApp />} />
          
            
            {/* Service Routes */}
            <Route path="/services/application-development" element={<ApplicationDevelopment />} />
            <Route path="/services/software-testing" element={<SoftwareTesting />} />
            <Route path="/services/it-consulting" element={<ITConsulting />} />
            <Route path="/services/erp-implementation" element={<ERPImplementation />} />
            <Route path="/services/digital-marketing" element={<DigitalMarketing />} />
            <Route path="/services" element={<Services />} />
            <Route path='/aboutus' element={<AboutUs />} />
            <Route path='/contactus' element={<ContactUs />} />
            <Route path="/services/it-training" element={<ITTraining />} />
          </Routes>
        </main>
      </div>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
